import React from 'react';
import { ChevronRight } from 'lucide-react';
import { BRAND_TIFFANY_BLUE } from '../../constants/branding';

type Props = {
  primaryLabel: string;
  onPrimary: () => void;
  primaryDisabled?: boolean;
  summary?: React.ReactNode;
  helperText?: string;
};

const ReserveStepFooter: React.FC<Props> = ({
  primaryLabel,
  onPrimary,
  primaryDisabled = false,
  summary,
  helperText,
}) => {
  return (
    <div
      className="sticky z-30 mt-auto pt-4"
      style={{ bottom: 'var(--reserve-footer-bottom, 80px)' }}
    >
      <div className="rounded-[24px] border border-[#d7efee] bg-[linear-gradient(180deg,rgba(244,253,252,0.98),rgba(255,255,255,0.96))] p-3 shadow-[0_18px_48px_rgba(10,186,181,0.14)] backdrop-blur-sm">
        <div className="flex items-center gap-3">
          <div className="min-w-0 flex-1 truncate text-sm font-medium text-slate-600">
            {summary ?? helperText ?? 'Ready to continue'}
          </div>
        <button
          type="button"
          onClick={onPrimary}
          disabled={primaryDisabled}
          className={[
              'flex min-h-[48px] shrink-0 items-center justify-center gap-2 rounded-2xl px-4 py-3 text-sm font-semibold transition',
            primaryDisabled
              ? 'cursor-not-allowed bg-slate-200 text-slate-400'
              : 'text-white shadow-[0_12px_28px_rgba(10,186,181,0.3)] hover:brightness-95',
          ].join(' ')}
          style={primaryDisabled ? undefined : { background: `linear-gradient(135deg, ${BRAND_TIFFANY_BLUE}, #089d99)` }}
        >
          {primaryLabel}
          {!primaryDisabled ? <ChevronRight className="h-5 w-5" /> : null}
        </button>
        </div>
      </div>
    </div>
  );
};

export default ReserveStepFooter;
